import { render, staticRenderFns } from "./WaitingForParts-ColumnAlpha.vue?vue&type=template&id=6ab1d541&"
import script from "./WaitingForParts-ColumnAlpha.vue?vue&type=script&lang=js&"
export * from "./WaitingForParts-ColumnAlpha.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForParts-ColumnAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports